import HttpRequest from "./HttpRequest";
import CRUDService from "./base/CRUDService";
import Notify from "./Notify";

export default class CompanyConfigurationService extends CRUDService {

  httpRequest = new HttpRequest();

  getBaseURL() {
    return "ton/v1/company-configurations/"
  };

  static companyConfigurations = [];
  static canShowWeight = "CAN_SHOW_WEIGHT"

  static COMPANY_CONFIGURATIONS_TYPES = {
    CAN_DO_TRANSACTION_SAME_LSD: "CAN_DO_TRANSACTION_SAME_LSD",
    CAN_SHOW_WEIGHT: "CAN_SHOW_WEIGHT",
    MOVEMENT_ORDER_URL: "MOVEMENT_ORDER_URL",
    KEY_TEGMA: "KEY_TEGMA",
    INVENTORY_CHECKPOINT_NOT_FOUND: "INVENTORY_CHECKPOINT_NOT_FOUND",
    INVENTORY_CHECKPOINT_UNEXPECTED: "INVENTORY_CHECKPOINT_UNEXPECTED",
    ASSET_DETAIL_BARCODE_COMPONENT: "ASSET_DETAIL_BARCODE_COMPONENT",
    HIDE_ASSET_SERIAL: "HIDE_ASSET_SERIAL"
  }

  getCompanyConfigurations() {
    const url = `ton/v1/company-configurations`;
    this.httpRequest.get(url).then(
      data => CompanyConfigurationService.companyConfigurations = data.content,
      error => Notify.error("Falha ao carregar configurações da empresa",
        error.message));
  }

  canShowWeight() {
    const configs = CompanyConfigurationService.companyConfigurations.filter(
      x => x.key === CompanyConfigurationService.canShowWeight && x.active === true)
    if (configs.length > 0) {
      const config = configs[0];
      return config.value;
    }
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/services/CompanyConfiguration.js